import ReactDOM from "react-dom/client";
import _ from "underscore";
import Backbone from "backbone";
import { StriimTheme } from "@striim/striim-ui";
import SentinelPanel from "../../../../../src/modules/ai-insights/sentinel/panel/sentinel-panel-container.tsx";
import api from "../../../../../core/api/api.js";
import metaStoreService from "../../../../../core/services/metaStoreService/meta-store-service.js";
import App from "app";
import { isUserAdmin } from "../../../../../core/user-management/update.control.js";
import GraphNodeModel from "../graphNodes/graphNodeModel";

const SentinelSidebarView = Backbone.Marionette.LayoutView.extend({
    template: _.template(`<div>   </div>`),

    initialize: function() {},

    getViewValue: function() {},

    setViewValue: function() {},

    setIsExpanded: function(isExpanded) {
        this._isExpanded = isExpanded;
        if (this.root) {
            this.onShow();
        }
    },

    setAppStatus: function(appStatus) {
        // Store the app status for use in rendering
        // The SentinelPanel will receive the updated flowStatus via props
        if (this.options.appModel) {
            this.options.appModel.flowStatus = appStatus;
        }
        // Re-render the panel with the new status if already shown
        if (this.root) {
            this.onShow();
        }
    },

    onShow: async function() {
        const appModel = this.options.appModel;
        const nodeModel = this.options.nodeModel;
        const onViewActivityClick = this.options.onViewActivityClick;
        const flowStatus = appModel.get("flowStatus");
        const entityDataFromSource = this.options.nodeModel.entityDataFromSource;
        const parentStream = this.options.nodeModel.parentStream ?? this.options.nodeModel?.parentNode?.id ?? "";
        try {
            if (!this.root) {
                this.root = ReactDOM.createRoot(this.$el[0]);
            }
            const streams = await appModel.getApplicationComponentsByType("STREAM");
            const sources = await appModel.getApplicationComponentsByType("SOURCE");
            const streamOptions = streams.map(item => ({
                label: item.name,
                value: item.id
            }));
            let currentNodeResponse;
            if (nodeModel.id !== GraphNodeModel.prototype.tempNodeId) {
                currentNodeResponse = await api._CRUDHandler("", "READ", {
                    id: nodeModel.id,
                    type: metaStoreService.entities.SENTINEL
                });
            }

            this.root.render(
                <StriimTheme preselector=".striim.materialize.light:not(#\20)">
                    <SentinelPanel
                        onCancel={() => {
                            this.trigger("cancel-sentinel");
                        }}
                        onDelete={() => {
                            this.trigger("delete-sentinel");
                        }}
                        setSentinelFormDirty={isDirty => {
                            this.trigger("isDirty", isDirty);
                        }}
                        onSave={(id, outputStream) => {
                            this.trigger("sentinel-save", {
                                id: id,
                                nodeTargets: _.map(appModel?.targets, _.clone),
                                outputStream: outputStream
                            });
                        }}
                        validateOnSave={(id, errorsCount) => {
                            App.vent.trigger("component:form-validation", {
                                modelId: id ?? GraphNodeModel.prototype.tempNodeId,
                                errorsCount: errorsCount
                            });
                        }}
                        onViewActivityClick={onViewActivityClick}
                        streams={streamOptions}
                        sources={sources}
                        appName={appModel?.name}
                        nsName={appModel?.nsName}
                        metaObjectType={nodeModel?.metaObject?.type}
                        parentStream={parentStream}
                        savedSentinelObject={currentNodeResponse?.[0]}
                        flowStatus={flowStatus}
                        isAdmin={isUserAdmin()}
                        entityDataFromSource={entityDataFromSource}
                        isSaved={!!currentNodeResponse?.[0]}
                        isExpanded={!!this._isExpanded}
                    />
                </StriimTheme>
            );
        } catch (e) {
            console.error("Error rendering", e);
        }
    },

    onBeforeDestroy() {
        if (this.root) {
            const root = this.root;
            this.root = null;
            setTimeout(() => root.unmount(), 0);
        }
    }
});

export default SentinelSidebarView;
